import React from 'react';

const LogoPhoneSystems = ({ className = "w-12 h-12" }) => (
  <svg className={className} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="48" height="48" rx="12" fill="#10B981"/>
    <path d="M16 14C16 12.8954 16.8954 12 18 12H26C27.1046 12 28 12.8954 28 14V32C28 33.1046 27.1046 34 26 34H18C16.8954 34 16 33.1046 16 32V14Z" fill="white"/>
    <path d="M20 18H24" stroke="#10B981" strokeWidth="2" strokeLinecap="round"/>
    <path d="M20 24H24" stroke="#10B981" strokeWidth="2" strokeLinecap="round"/>
    <circle cx="32" cy="30" r="6" fill="white"/>
    <path d="M30 30L32 32L34 28" stroke="#10B981" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export default LogoPhoneSystems;
